export default {"src":"/_next/static/media/filter.3f6e9f5f.svg","height":28,"width":34,"blurWidth":0,"blurHeight":0};